import React from 'react';
import { useSelector } from 'react-redux';
import { SummaryLabelledInfo } from '../labelled-info';
import { selectBuyPowerOfAttorneyPersonFactory } from '../../../../../../services/buy-process/selectors';

interface SummaryProxiesProps {
  orderId: string;
}

export const SummaryProxies = ({ orderId }: SummaryProxiesProps) => {
  const proxies = useSelector(selectBuyPowerOfAttorneyPersonFactory(orderId));

  return (
    <React.Fragment>
      <SummaryLabelledInfo label="Samtliga förnamn">
        {proxies?.firstName}
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Efternamn">
        {proxies?.lastName}
      </SummaryLabelledInfo>

      <SummaryLabelledInfo label="Personnummer">
        {proxies?.socialSecurityNumber}
      </SummaryLabelledInfo>
    </React.Fragment>
  );
};
